import { User } from "./types";

export const createSsoUserDisplayName = (ssoUser) => {
  if (
    "first_name" in ssoUser &&
    "last_name" in ssoUser &&
    ssoUser.first_name &&
    ssoUser.last_name
  ) {
    return [ssoUser.first_name, ssoUser.last_name]
      .filter((val) => !!val?.trim())
      .join(" ");
  }
  return ssoUser.username ?? ssoUser.email;
};

export const parseSsoUser = (ssoUser): User => {
  const displayName = createSsoUserDisplayName(ssoUser);

  return {
    id: ssoUser.uuid,
    firstName: ssoUser.first_name,
    lastName: ssoUser.last_name,
    displayName,
    email: ssoUser.email,
    picture: ssoUser.picture,
  };
};
